import TransactionsTableSkeleton from './transactions-table.skeleton'
import { useNavigate } from 'react-router'
import useGetPendingTransactions from '../hooks/use-get-pending-transactions'
import { Button } from '@/components'
import { useGetPostedTransactions } from '../hooks/use-get-posted-transactions'
import { TransactionTableHeader } from '../transactions-page/tabs/all-transactions/transaction-table-header'
import { Table, TableBody } from '@/components/ui/table'
import { ROUTE_TRANSACTIONS, ROUTE_TRANSACTIONS_ALL_TRANSACTIONS } from '../../routes/paths'
import PostedTransactionsRaws from '../transactions-page/tabs/all-transactions/posted-transactions-rows'
import PendingTransactionsRows from '../transactions-page/tabs/all-transactions/pending-transactions-rows'

const TransactionsTable = () => {
  const navigate = useNavigate()
  const { data: trData, isLoading: isPendingTransactionLoading } = useGetPostedTransactions() || []
  const { data: pendingTransactionsData, isLoading: isPostedTransactionLoading } = useGetPendingTransactions()
  const postedTransactions = trData?.pages?.flatMap(page => page.transactions) || []
  const pendingTransactions = pendingTransactionsData?.node?.financialAccountActivities?.edges || []

  const isLoading = isPendingTransactionLoading || isPostedTransactionLoading
  return (
    <div className="w-full h-auto py-8 px-4 md:px-5">
      <div className="flex items-center justify-between">
        <p className="text-neutral-700 font-semibold">Transactions</p>
        <Button
          variant="link"
          className="text-xs"
          onClick={() => {
            navigate(`/${ROUTE_TRANSACTIONS}${ROUTE_TRANSACTIONS_ALL_TRANSACTIONS}`)
            window.scrollTo(0, 0) // scroll to top of transactions page
          }}
        >
          View All
        </Button>
      </div>
      <div className="flex flex-col">
        <Table>
          <TransactionTableHeader page="home" />
          <TableBody>
            <PendingTransactionsRows data={pendingTransactions} page={'home'} />
            <PostedTransactionsRaws data={postedTransactions} page={'home'} />
          </TableBody>
        </Table>
        {isLoading && <TransactionsTableSkeleton />}
        {!(pendingTransactions?.length || postedTransactions?.length) && !isLoading && (
          <p className="font-normal text-sm text-neutral-700 w-full mt-5">No transactions available</p>
        )}
      </div>
    </div>
  )
}

export default TransactionsTable
